<template>
  <div>
    <v-card class="mb-7" flat :disabled="loading">
      <v-card-title> Conclusão </v-card-title>

      <v-card-text>
        <p>Confirme uma última vez as informações a enviar à sua seguradora.</p>

        <v-row v-if="insured.contracts && insured.contracts.length > 0">
          <v-col>
            <div class="section">Processo</div>
            <v-card flat color="#f1f1f1">
              <v-simple-table
                style="background-color: transparent"
                class="pa-3"
              >
                <tbody>
                  <tr>
                    <th width="150px">Apólice</th>
                    <td>{{ insured.contracts[0].policyNumber }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <div class="section">Segurado</div>
            <v-card flat color="#f1f1f1">
              <v-simple-table
                style="background-color: transparent"
                class="pa-3"
              >
                <tbody>
                  <tr>
                    <th width="150px">Nome</th>
                    <td>{{ insured.name }}</td>
                  </tr>
                  <tr>
                    <th>Email</th>
                    <td>{{ insured.email }}</td>
                  </tr>
                  <tr>
                    <th>Contactos</th>
                    <td>
                      {{
                        [insured.contact1, insured.contact2]
                          .filter((i) => !!i)
                          .join(", ")
                      }}
                    </td>
                  </tr>
                  <tr v-if="insuredAddress">
                    <th>Morada</th>
                    <td>{{ formatAddress(insuredAddress) }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <div class="section">
              Participação
              <v-btn
                @click="setStep('2')"
                small
                outlined
                class="ml-2"
                :color="insurer.color"
              >
                <v-icon left>mdi-pencil</v-icon>
                Corrigir
              </v-btn>
            </div>
            <v-card flat color="#f1f1f1">
              <v-card-text> <b>Descrição: </b>{{ participation }} </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col>
            <v-card flat color="#f1f1f1">
              <v-card-text>
                <b>Data da ocorrência: </b>{{ formatDate(date) }}
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <div class="section">
              Equipamentos
              <v-btn
                @click="setStep('3')"
                small
                outlined
                class="ml-2"
                :color="insurer.color"
              >
                <v-icon left>mdi-pencil</v-icon>
                Corrigir
              </v-btn>
            </div>
            <EquipamentCard
              v-for="equipament in equipaments"
              :key="equipament.id"
              class="mb-4"
              :equipament="equipament"
              readonly
            >
            </EquipamentCard>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <ResumeCard :equipaments="equipaments"></ResumeCard>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-btn
          :loading="loading"
          :color="insurer.color"
          @click="
            $emit('continue', {
              equipaments: buildEquipamentsPayload(),
              participation,
              insured: buildInsuredPayload(),
              date,
              insurer: $route.params.token,
            })
          "
          dark
        >
          Confirmar
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { formatDate } from "@/tools/date";
import EquipamentCard from "./ EquipamentCard.vue";
import ResumeCard from "./ResumeCard.vue";

export default {
  name: "ConclusionRE",
  mixins: [],

  components: {
    EquipamentCard,
    ResumeCard,
  },

  props: {
    disabled: Boolean,
    loading: {
      type: Boolean,
      default: false,
    },
    insurer: Object,
  },

  data() {
    return {
      equipaments: [],
      participation: "",
      insured: {},
      date: "",
      formatDate,
      insuredAddress: null,
    };
  },

  methods: {
    // getAddressFormatted() {
    //   const address = this.insured.address;

    //   return `${address.street}, Nº ${address.number} ${address.postalCode} ${address.city} ${address.countryArea}`;
    // },

    formatAddress(address) {
      if (!address) return "—";

      return [
        address.street,
        `nº ${address.number}`,
        address.local,
        address.postal_code,
        address.city?.name,
        address.country_area?.name,
      ]
        .filter(Boolean)
        .join(", ");
    },

    buildInsuredPayload() {
      const insured = { ...this.insured };

      const contractAddress = insured?.contracts?.[0]?.address;

      if (contractAddress) {
        insured.address = {
          postalCode: contractAddress.postal_code,
          street: contractAddress.street,
          number: contractAddress.number,
          cityArea:
            contractAddress.city_area?.name ||
            contractAddress.city?.name ||
            null,
        };
      }

      return insured;
    },

    buildEquipamentsPayload() {
      return this.equipaments.map((equipament) => {
        const normalized = { ...equipament };

        if (!normalized.repairman) {
          delete normalized.repairman;
        }

        return normalized;
      });
    },

    loadProducts() {
      const payload = localStorage.getItem("equipaments");
      if (!payload) {
        return;
      }

      this.equipaments = JSON.parse(payload);
    },
    loadParticipation() {
      const participation = localStorage.getItem("participation");
      if (!participation) {
        return;
      }

      this.participation = participation;
    },
    loadDate() {
      const date = localStorage.getItem("date");
      if (!date) {
        return;
      }

      this.date = date;
    },
    loadInsured() {
      const insured = localStorage.getItem("insured");
      if (!insured) {
        return;
      }

      this.insured = JSON.parse(insured);

      this.insuredAddress = this.insured.contracts?.[0]?.address || null;
    },

    setStep(step) {
      this.$emit("setStep", step);
    },
    refresh() {
      this.loadProducts();
      this.loadParticipation();
      this.loadInsured();
      this.loadDate();
    },
  },

  computed: {},

  created() {
    this.refresh();
  },
};
</script>

<style lang="scss" scoped>
.section {
  font-size: medium;
  margin-bottom: 1.1rem;
  margin-top: 1.1rem;
}
</style>
